// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"2f166b2d","118":"09df59ee","327":"0151542b","460":"0f5b95d6","497":"e39c73bf","544":"8c20e416","632":"e7a99720","827":"f5a0bbf4","952":"0f5b95d6"}[chunkId] + ".chunk.css";
};